import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../../shared/Inputs/TextInput/TextInput'
import DatePicker from '../../../../shared/Inputs/DatePicker/DatePicker'
import { UPLOADS_ENDPOINT } from '../../../../server-parameters'
import { yearsAgo } from '../../../../utils/helpers'
import { validateDate, passportDigits } from '../../../../validate/validators'
import { Lang } from '../../../../types/common-types'
import { State } from '../../../../state-actions-reducers'
import FileInput from '../../../../shared/Inputs/FileInput/FileInput'
import { PassportType } from '../../../../enums/passportTypeEnum'
import IdentityExist from '../../../../components/IdentityExist/IdentityExist'
import CheckBoxInput from '../../../../shared/Inputs/CheckBoxInput/CheckBoxInput'

export default function TurkmenistanForm({
  lang,
  accountForm,
}: { lang: Lang; accountForm: any }) {
  const { watch, setValue, formState: { errors } } = useFormContext<State>()
  const state = watch()
  const [focus, setFocus] = useState('')
  return (
    <>
      {Number(state.passportType) === PassportType.Passport ? (
        <>
          <div className="col-2 col-xs-12">
            {/* PASSPORT SERIES / NUMBER */}
            <TextInput
              testName="passportNumber"
              testErrorName="error-passportNumber"
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.documentNumberTkm}
              onChange={passportNumber => {
                setValue('passportNumber', passportNumber.toUpperCase(), { shouldDirty: true })
              }}
              value={state.passportNumber}
              required
              valid={
                passportDigits(state.passportNumber) &&
                !errors.passportNumber
              }
              onBlur={() => setFocus('')}
              mask={'a9999999'}
            />
          </div>
          <IdentityExist
            accountForm={accountForm}
            lang={lang}
            show={!state.isIdentityOk}
          />
          <div className="col-2 col-xs-12">
            {/* PASSPORT ISSUE DATE */}
            <DatePicker
              testName="passportIAt"
              testErrorName="error-passportIAt"
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportIAt"
              onChange={data => setValue('passportIAt', data, { shouldDirty: true })}
              value={state.passportIAt}
              required
              valid={
                !errors.passportIAt &&
                validateDate({
                  current: state.passportIAt,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              curr={new Date()}
              min={
                new Date(new Date().setFullYear(new Date().getFullYear() - 10))
              }
              max={new Date()}
            />
          </div>
          <div className="col-8 col-xs-12">
            {/* PASSPORT ISSUED BY */}
            <TextInput
              testName="passportIssuedBy"
              testErrorName="error-passportIssuedBy"
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.issuedBy}
              onChange={passportIssuedBy =>
                setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
              }
              value={state.passportIssuedBy}
              required
              valid={
                !errors.passportIssuedBy
              }
              onBlur={() => setFocus('')}
            />
          </div>
          <div className="col-3 col-xs-12">
            {/* PASSPORT EXPIRY DATE */}
            <DatePicker
              testName="passportExpiryDate"
              testErrorName="error-passportExpiryDate"
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportExpiryDate"
              onChange={data =>
                setValue('passportExpiryDate', data, { shouldDirty: true })
              }
              value={state.passportExpiryDate}
              required
              valid={
                !errors.passportExpiryDate &&
                validateDate({
                  current: state.passportExpiryDate,
                  min: new Date(),
                  max: new Date(
                    new Date().setFullYear(new Date().getFullYear() + 10)
                  ),
                })
              }
              onBlur={() => setFocus('')}
              min={new Date()}
              max={
                new Date(new Date().setFullYear(new Date().getFullYear() + 10))
              }
            />
          </div>
          <div className="col-3 col-xs-12">
            {/* PASSPORT DATE BOARDING*/}
            <DatePicker
              testName="passportDateBoardCrossing"
              testErrorName="error-passportDateBoardCrossing"
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportDateBoardCrossing"
              onChange={data =>
                setValue('passportDateBoardCrossing', data, { shouldDirty: true })
              }
              value={state.passportDateBoardCrossing}
              required
              valid={
                !errors.passportDateBoardCrossing &&
                validateDate({
                  current: state.passportDateBoardCrossing,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              max={new Date()}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName="mainImageFile"
              testErrorName="error-mainImageFile"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.passportImages}
              content={accountForm.mainImageFile}
              onChange={data => {
                setValue('mainImageFile', data, { shouldDirty: true })
              }}
              valid={!errors.mainImageFile}
              documentType="Passport1"
              value={state.mainImageFile[state.mainImageFile.length - 1]}
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName="addressImageFile"
              testErrorName="error-addressImageFile"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.passportImages}
              content={accountForm.arrivalStampFile}
              onChange={addressImageFile => {
                setValue('addressImageFile', addressImageFile, { shouldDirty: true })
              }}
              value={state.addressImageFile[state.addressImageFile.length - 1]}
              valid={!errors.addressImageFile}
              documentType="Passport2"
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName="visaImageFile"
              testErrorName="error-visaImageFile"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.passportImages}
              content={accountForm.visaImageFile}
              onChange={visaImageFile => {
                setValue('visaImageFile', visaImageFile, { shouldDirty: true })
              }}
              value={state.visaImageFile[state.visaImageFile.length - 1]}
              valid={!errors.visaImageFile}
              documentType="Passport3"
              imageErrors={state.imageError}
            />
          </div>
          <div
            className={'col-12 dateBoardCheckBox'}
          >
            <CheckBoxInput
              data-test-id="passportDateBoardCheck"
              name="passportDateBoardCheck"
              onChange={() =>
                setValue('passportDateBoardCheck', !state.passportDateBoardCheck, { shouldDirty: true })
              }
              label={accountForm.passportDateBoardCheck90RF.label}
              lang={lang}
              value={state.passportDateBoardCheck ?? false}
              valid={!!errors.passportDateBoardCheck}
            />
          </div>
        </>
      ) : Number(state.passportType) === PassportType.ResidencePermit ? (
        <>
          <div className="col-2 col-xs-12">
            {/* NUMBER */}
            <TextInput
              testName="passportPermanentResidencyNumber"
              testErrorName="error-passportPermanentResidencyNumber"
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.passportInternationalNumberRus}
              onChange={number => {
                setValue('passportPermanentResidencyNumber', number, { shouldDirty: true })
              }}
              value={state.passportPermanentResidencyNumber}
              required
              valid={
                passportDigits(state.passportPermanentResidencyNumber) &&
                !errors.passportPermanentResidencyNumber
              }
              onBlur={() => setFocus('')}
              mask={'99 9999999'}
            />
          </div>
          <div className="col-2 col-xs-12">
            {/* PASSPORT PERMANENT RESIDENCY DATE */}
            <DatePicker
              testName="passportDateIssuePermanentResidency"
              testErrorName="error-passportDateIssuePermanentResidency"
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportDateIssuePermanentResidency"
              onChange={data =>
                setValue('passportDateIssuePermanentResidency', data, { shouldDirty: true })
              }
              value={state.passportDateIssuePermanentResidency}
              required
              valid={
                !errors.passportDateIssuePermanentResidency &&
                validateDate({
                  current: state.passportDateIssuePermanentResidency,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              min={
                state.birthDate
                  ? new Date(
                    new Date(state.birthDate).setFullYear(
                      new Date(state.birthDate).getFullYear()
                    )
                  )
                  : new Date(
                    new Date().setFullYear(new Date().getFullYear() - 67)
                  )
              }
              max={new Date()}
            />
          </div>
          <div className="col-8 col-xs-12">
            {/* ISSUED BY */}
            <TextInput
              testName="passportIssuedBy"
              testErrorName="error-passportIssuedBy"
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.issuedBy}
              onChange={passportIssuedBy =>
                setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
              }
              value={state.passportIssuedBy}
              required
              valid={
                !errors.passportIssuedBy
              }
              onBlur={() => setFocus('')}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName="residenceImageFile"
              testErrorName="error-residenceImageFile"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.passportImages}
              content={accountForm.residenceFile}
              onChange={residenceImageFile => {
                setValue('residenceImageFile', residenceImageFile, { shouldDirty: true })
              }}
              value={
                state.residenceImageFile[state.residenceImageFile.length - 1]
              }
              valid={!errors.residenceImageFile}
              documentType="Passport1"
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName="addressImageFile"
              testErrorName="error-addressImageFile"
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.passportImages}
              content={accountForm.residenceBacksideFile}
              onChange={data => {
                setValue('addressImageFile', data, { shouldDirty: true })
              }}
              value={state.addressImageFile[state.addressImageFile.length - 1]}
              valid={!errors.addressImageFile}
              documentType="Passport2"
              imageErrors={state.imageError}
            />
          </div>
        </>
      ) : null}
    </>
  )
}
